import clsx from "clsx";
import React, { DetailedHTMLProps, FC, HTMLAttributes, PropsWithChildren } from "react";

import { Icon, IconName } from "../../icon";

interface SideCtaItemProps
  extends Pick<React.DOMAttributes<HTMLDivElement>, "onClick">,
    Pick<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "className"> {
  variant?: "light" | "neutral";
  icon: IconName;
  isMobile: boolean;
}

export const SideCtaItem: FC<PropsWithChildren<SideCtaItemProps>> = ({
  variant = "neutral",
  icon,
  isMobile,
  children,
  className,
  ...buttonProps
}) => {
  return (
    <div
      {...buttonProps}
      className={clsx(
        "transition-all duration-300 group border-2 cursor-pointer",
        isMobile
          ? "rounded-full p-3"
          : "rounded-l-full h-12 pl-3 pr-6 w-full inline-flex items-center translate-x-0 hover:translate-x-[calc(-100%+50px)] border-r-0",
        {
          "bg-white text-primary border-gray-300": variant === "light",
          "bg-black text-white border-primary": variant === "neutral",
        },
        className
      )}
    >
      <Icon
        icon={icon}
        size={20}
        className={clsx("cursor-pointer", isMobile ? "w-6 h-6" : "inline mr-4 flex-none")}
      />
      {children}
    </div>
  );
};
